import { OnlineLearningRegistrationData } from 'models'
import { Moment } from 'moment'
import { BaseModel } from './base.model'
import { User } from './user.model'

/**
 * Объект для сохранения дополнительной информации о регистрации при создании ссылки
 */
export class OnlineLearningRegistrationLink extends BaseModel<OnlineLearningRegistrationLink> {
  registrationId: number
  creatorId: number
  link: string
  data: OnlineLearningRegistrationData
  sent: boolean
  createdAt: Moment
  updatedAt: Moment
  creator: User
  completeLink: string
  phone: string
  license: string
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/online-learning-registration-link.model.ts